import React from 'react';
import {ResponseCSV} from "./UpdateExpirationCardsContainer";
import {
    LoadingView,
    UploadField,
    Button,
    Icon,
    IconsBase,
} from "@cuatroochenta/co-admin-react-library";
import './UpdateExpirationCardsView.scss';

interface UpdateExpirationCardsProps {
    importCSV: (file: File, stopLoading: () => void) => void
    response: ResponseCSV | null
}

interface state {
    file: File | null
    loading: boolean,
    helperTextFileSelector: string,
    helperTextFieldSelector: string,
}

class UpdateExpirationCards extends React.Component<UpdateExpirationCardsProps> {

    public state: state = {
        file: null,
        loading: false,
        helperTextFileSelector: '',
        helperTextFieldSelector: '',
    };

    public onUploadFile(file: File | null): void {
        this.setState({
            file: file,
            helperTextFileSelector: '',
        });
    }

    public handleRemoveFile(): void {
        this.setState({
            file: null,
            helperTextFileSelector: 'Campo obligatorio',
        });
    }

    importCSV(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault()
        this.setState({
            helperTextFileSelector: this.state.file ? '' : 'Campo obligatorio',
        });
        if (this.state.file !== null && !this.state.loading) {
            this.setState({loading: true});
            this.props.importCSV(this.state.file, () => {
                this.setState({loading: false})
            })
        }
    }

    private renderGenerateButton() {
        return (
            <div className="row">
                <div className="col">
                    <Button
                        type={'submit'}
                        content={
                            <>
                                <Icon
                                    fontAwesomeClass={IconsBase.QR}
                                />
                                <span>{` Cargar el CSV`}</span>
                            </>
                        }
                    />
                </div>
            </div>
        )
    }

    private renderMessageCard() {
        if (this.props.response === null || this.state.loading) {
            return null;
        }

        if (this.props.response.success) {
            return this.renderMessage(this.props.response.message);
        }

        return this.renderMessage(this.props.response.error, {color: "red"});
    }

    private renderMessage(message: string | null, style: {} = {}) {
        return (
            <div className="col-md-12">
                <div className="card shadow p-3">
                    <div className="card-body">
                        <div className="message">
                            <div style={{ ...style, margin: 0, whiteSpace: 'pre-wrap' }}>
                              {message}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderFileSelector(): React.ReactNode {

        return (
            <div className="col-md-12">
                <div className="form-group">
                    <UploadField
                        value={!!this.state.file ? this.state.file.name : ''}
                        field={'file'}
                        type={'file'}
                        disabled={false}
                        removeFile={() => this.handleRemoveFile()}
                        isEditScreen={true}
                        name={''}
                        label={'File*'}
                        taskUpload={(e: any) => this.onUploadFile(e.target.files ? e.target.files[0] : null)}
                        helperText={this.state.helperTextFileSelector}
                        onClickUploadButton={() => this.setState({helperTextFileSelector: 'Campo obligatorio'})}
                    />
                </div>
            </div>
        );
    }

    public render() {
        if (this.state.loading) {
            return <LoadingView loading={this.state.loading}/>;
        }

        return (
            <div className={"component-import-gtfs-view"}>
                {this.renderMessageCard()}
                <div className="col-md-12">
                    <div className="card shadow p-3">
                        <div className="card-body">
                            <form onSubmit={(e) => this.importCSV(e)}>
                                <div className={"row"}>
                                    {this.renderFileSelector()}
                                </div>
                                {this.renderGenerateButton()}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UpdateExpirationCards;